module.exports = __webpack_public_path__ + "static/media/logo-dark.87fc99c6.png";